import { connect } from 'react-redux'
import { getArchivedReferralsList } from '../actions/actions-archived-referrals'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import ArchivedReferrals from '../views/ArchivedReferrals/archived-referrals'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    archivedreferrals: state.archivedreferralsR.dataList,
    programsAssigned: state.programsR.programsassignedtologin
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getArchivedReferrals: loginID => {
      dispatch(getArchivedReferralsList(loginID))
    },
    getProgramsAssignedToLoginList: id => {
      dispatch(getProgramsAssignedToLoginList(id))
    }
  }
}
const ArchivedReferralListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ArchivedReferrals)
export default ArchivedReferralListContainer
